import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedCameraIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("mask", {
			id: "path-1-outside-1_404_386",
			maskUnits: "userSpaceOnUse",
			x: 2,
			y: 4,
			width: 20,
			height: 17,
			fill: "black",
			children: [/* @__PURE__ */ _jsx("rect", {
				fill: "white",
				x: 2,
				y: 4,
				width: 20,
				height: 17
			}), /* @__PURE__ */ _jsx("path", { d: "M13.4648 6C13.7992 6.00001 14.1114 6.16712 14.2969 6.44531L15.333 8H18C19.1046 8 20 8.89543 20 10V17C20 18.1046 19.1046 19 18 19H6C4.89543 19 4 18.1046 4 17V10C4 8.89543 4.89543 8 6 8H8.5L9.22363 6.55273C9.39303 6.21398 9.73941 6 10.1182 6H13.4648Z" })]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.4648 6L13.4649 4.5H13.4648V6ZM14.2969 6.44531L15.5451 5.61344L15.545 5.61326L14.2969 6.44531ZM15.333 8L14.0848 8.83187L14.5301 9.5H15.333V8ZM8.5 8V9.5H9.42705L9.84164 8.67082L8.5 8ZM9.22363 6.55273L7.88203 5.88184L7.88199 5.88191L9.22363 6.55273ZM13.4648 6L13.4648 7.5C13.2976 7.5 13.1415 7.41644 13.0488 7.27736L14.2969 6.44531L15.545 5.61326C15.0813 4.91781 14.3008 4.50002 13.4649 4.5L13.4648 6ZM14.2969 6.44531L13.0487 7.27718L14.0848 8.83187L15.333 8L16.5812 7.16813L15.5451 5.61344L14.2969 6.44531ZM15.333 8V9.5H18V8V6.5H15.333V8ZM18 8V9.5C18.2761 9.5 18.5 9.72386 18.5 10H20H21.5C21.5 8.067 19.933 6.5 18 6.5V8ZM20 10H18.5V17H20H21.5V10H20ZM20 17H18.5C18.5 17.2761 18.2761 17.5 18 17.5V19V20.5C19.933 20.5 21.5 18.933 21.5 17H20ZM18 19V17.5H6V19V20.5H18V19ZM6 19V17.5C5.72386 17.5 5.5 17.2761 5.5 17H4H2.5C2.5 18.933 4.067 20.5 6 20.5V19ZM4 17H5.5V10H4H2.5V17H4ZM4 10H5.5C5.5 9.72386 5.72386 9.5 6 9.5V8V6.5C4.067 6.5 2.5 8.067 2.5 10H4ZM6 8V9.5H8.5V8V6.5H6V8ZM8.5 8L9.84164 8.67082L10.5653 7.22355L9.22363 6.55273L7.88199 5.88191L7.15836 7.32918L8.5 8ZM9.22363 6.55273L10.5652 7.22363C10.4804 7.39321 10.3073 7.5 10.1182 7.5V6V4.5C9.1715 4.5 8.30563 5.03475 7.88203 5.88184L9.22363 6.55273ZM10.1182 6V7.5H13.4648V6V4.5H10.1182V6Z",
			fill: "#333333",
			mask: "url(#path-1-outside-1_404_386)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 13.5,
			r: 3,
			stroke: "#333333",
			strokeWidth: 1.5
		})
	]
});
const ForwardRef = forwardRef(SvgOutlinedCameraIcon);
const Memo = memo(ForwardRef);
export default Memo;
